const GUEST_TEMPORARY_INPUT_KEY = 'GUEST_TEMPORAY_INPUT'

export default class GuestTemporaryInput {
  static get data() {
    if (!window.sessionStorage) {
      return false
    }
    if (!window.sessionStorage[GUEST_TEMPORARY_INPUT_KEY]) {
      window.sessionStorage.setItem(GUEST_TEMPORARY_INPUT_KEY, '{}')
    }
    this._data = JSON.parse(window.sessionStorage[GUEST_TEMPORARY_INPUT_KEY])
    return this._data
  }

  static set data(data) {
    if (!data) {
      return
    }
    this._data = data
    window.sessionStorage.setItem(
      GUEST_TEMPORARY_INPUT_KEY,
      JSON.stringify(this._data)
    )
  }

  static clear() {
    this._data = {}
    window.sessionStorage.removeItem(GUEST_TEMPORARY_INPUT_KEY)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/GuestTemporaryInput.js